// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1077":"73abb96747def1e0","3125":"f47c8265b54b6370","3687":"c22208286ce47c9a"}[chunkId] + ".js";
};